import http from "./httpService";
const url = "https://wms.advanceagro.net/ws2/api";
//const url = "http://127.0.0.1:8080/api";

export async function scalelist(
  id = 0,
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
     "/truckscale/truckscalelist?groupid=" +
      id + "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&name=" +
      search 
  );
}
export async function getgroups() {
  return http.get("/truckscale/truckscalegroup");
}
export async function brancselected() {
  return http.get("/truckscale/branchselected");
}
export async function truckscalegroupselected() {
  return http.get("/truckscale/groupselected");
}
export async function sizeselected() {
  return http.get("/truckscale/sizeselected");
}
export async function loadcellselected() {
  return http.get("/truckscale/loadcellselected");
}
export async function indicatorselected() {
  return http.get("/truckscale/indicatorselected");
}
export async function readerselected() {
  return http.get("/truckscale/readerselected");
}
export async function controllerselected() {
  return http.get("/truckscale/controllerselected");
}

export async function gettruckdaily(id=0) {
  return http.get("/truckscale/reportbyday?id="+id);
}

export async function gettruckperhour(id=0,startdate ) {
  return http.get("/truckscale/reportperhour?id="+id + "&startdate="+startdate);
}

export async function getlprmonthly(name="",branchid="" ) {
  return http.get("/truckscale/reportlprmonthly?truckname="+name +"&branchid=" + branchid);
}

export async function getlprweekly(name="",branchid="" ) {
  return http.get("/truckscale/reportlprweelly?truckname="+name +"&branchid=" + branchid);
}
export async function getweightdetail(name="",branchid="",hour ="",startdate="" ) {
  return http.get("/truckscale/wieghtdetail?truckname="+name +"&branchid=" + branchid +"&hour="+ hour +"&startdate="+startdate);
}

export async function getlprdetail(startdate="",typeid =0 ,name="",branchid="") {
  return http.get("/truckscale/getlprdetail?startdate="+startdate +"&typeid=" + typeid +"&branchid=" + branchid + "&truckname="+name );
}
export async function getImageType() {
  return http.get("/truckscale/getimagetype");
}

export async function getImagelist(id) {
  return http.get("/truckscale/getImagelist?id=" +id);
}
export async function saveImage(doc) {
  return http.post(url +"/truckscale/UploadImage", doc);
}
export async function saveTruckinfo(doc) {
  return http.post("/truckscale/savetruckinfo", doc);
}


export async function gettruckscaleinfor(id=0) {
  return http.get("/truckscale/truckscaleinfor?id="+id);
}
export async function getLastLPR(name="",branchid="") {
  return http.get("/truckscale/getLastLPR?truckname="+name +"&branchid=" + branchid);
}
export async function getcctv(id=0) {
  return http.get("/truckscale/getcctv?id="+id );
}


